import { useRef, useContext, useState, useEffect, createRef } from 'react';

import { GlobalContext } from "../../contexts/globalContext";
import { ProjectDetailsContext } from '../../contexts/projectDetailsContext';

import styles from './AddTopicsComponent.module.css'
import uuid from 'react-uuid';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { byPrefixAndName } from '@awesome.me/kit-fe6b9b7683/icons';

import PopupBodyComponent from './common/PopupBodyComponent';
import PopupBaseComponent from './common/PopupBaseComponent';
import ClosePageButtonComponent from '../commons/ClosePageButtonComponent'
import LightButtonComponent from '../commons/LightButtonComponent';
import LeftBodyComponent from './common/LeftBodyComponent';
import RightBodyComponent from './common/RightBodyComponent';
import FooterButtonsComponent from './common/FooterButtonsComponent';
import New_InputTextComponent from '../keyboard/New_InputTextComponent';

import topicsAdd from '../../graphics/Popups/Icon Folders Add.png'

const AddTopicsComponent = () => {
    
    const { 
        setTopicFiles, setSelectedTopic, setSelectedRefTypeForFiles, setSelectedParentForFiles, selectedTopicIdRef,
        selectedProject, setSelectedProject, socketRef, keyboardRef 
    } = useContext(GlobalContext);
    
    const { setAddTopic, editTopic, setEditTopic } = useContext(ProjectDetailsContext);

    const nameRef = useRef()
    const subtopicRef = useRef()

    const [showAddSubtopic, setShowAddSubtopic] = useState(false)
    const [showAddButton, setShowAddButton] = useState(false)
    const [currentSubtopicList, setCurrentSubtopicList] = useState(editTopic?.subtopics || []);

    const fileRefs = useRef(currentSubtopicList.map(() => createRef()));

    useEffect(() => {
        if (editTopic) {
            setShowAddSubtopic(true);
        }
    }, [])

    function handleTopicAdd() {
        let subtopicsList = []
        subtopicsList = currentSubtopicList.map(subtopic => subtopic.name)
        socketRef.current.emit("PROJECT_UPDATE_FOLDER",
            {
                projectId: selectedProject._id,
                topicId: editTopic ? editTopic._id : null,
                newData: {
                    name: nameRef.current?.value ? nameRef.current?.value : "Default Title",
                    subtopics: currentSubtopicList
                }
            }, (callback) => {
                if (!callback.error) {
                    const id = callback.response

                    selectedTopicIdRef.current = id;
                    setSelectedParentForFiles({ _id: id, name: nameRef.current?.value ? nameRef.current?.value : "Default Title" });
                    setSelectedRefTypeForFiles("Topic");
                    setSelectedTopic(id)

                    socketRef.current.emit("PROJECT_GET_FOLDER_ATTACHED_DOCUMENTS", { parentId: id }, (docs) => {
                        setTopicFiles(docs);
                        setAddTopic()
                        setEditTopic()
                    });
                }
            }
        );
    }

    function handleSubtopicAdd() {
        setCurrentSubtopicList((prev) => [...prev, { name: subtopicRef.current?.value || "Default Title", _id: uuid(), isNew: true }]);
        fileRefs.current.push(createRef());
        subtopicRef.current.value = "";
    }

    const handleDeleteSubtopic = (subtopic) => {
        if (editTopic && !subtopic.isNew) {
            socketRef.current.emit(
                "PROJECT_DELETE_SUBFOLDER",
                { subtopicId: subtopic._id, topicId: editTopic._id, projectId: selectedProject._id },
                (callback) => {
                    if (!callback.error) {
                        setSelectedProject(prev => ({
                            ...prev,
                            topics: prev.topics.map(topic => 
                                topic._id === editTopic._id ? callback.response : topic
                            )
                        }));
                        setTopicFiles(callback.response);
                    }
                }
            );
        }

        let subtopicsList = currentSubtopicList
        
        let filteredSubtopicsList = subtopicsList.filter(st => st._id !== subtopic._id);
        setCurrentSubtopicList(filteredSubtopicsList)
    };

    function closePopup() {
        setAddTopic()
        setEditTopic()
    }

    const topicNameSave_handler = () => {
        if (nameRef.current?.value) {
            setShowAddSubtopic(true);
        } else {
            setShowAddSubtopic(false);
            setShowAddButton(false);
        }
    }

    const subtopicNameSave_handler = () => {
        if (subtopicRef.current?.value) {
            setShowAddButton(true);
        } else {
            setShowAddButton(false);
        }
    }

    return (
        <PopupBaseComponent>
            <PopupBodyComponent style={{ width: 2760, height: 1040 }}>
                <ClosePageButtonComponent setClose={closePopup} />
                <LeftBodyComponent image={topicsAdd} title="New folder and subfolders" description="Enter a folder name to organize your files. You can also add multiple optional subfolders at any time to build or expand your file structure as needed." />
                <RightBodyComponent>
                    <div className={styles.body_header} >
                        Folder Name
                    </div>

                    <New_InputTextComponent ref={nameRef} height="80px" keyboardRef={keyboardRef} value={editTopic ? editTopic.name : ""} placeHolder="Enter topic name here" styleType='POPUP' fontSize="40px" width="1600px"
                        iconPosition="right" icon={byPrefixAndName.fas["pen"]} withDelete={true} onChange={() => topicNameSave_handler()}
                    />
                    <div className={styles.subtopics}>
                        <div className={styles.subtopicsHeader}>
                            Subfolders
                            <div className={styles.subtopicsOptional}>(Optional)</div>
                        </div>

                        <div className={styles.subtopics_map}>

                            {currentSubtopicList.length > 0 && currentSubtopicList.map((subtopic, index) =>
                                <div key={subtopic._id} className={styles.subtopicsAdd}>
                                    <New_InputTextComponent ref={fileRefs.current[index]} height="80px" keyboardRef={keyboardRef}
                                        value={subtopic.name} placeHolder="Enter subtopic name here" styleType={'POPUP'}
                                        fontSize="40px" width={"1560px"} />
                                    <LightButtonComponent onClick={() => handleDeleteSubtopic(subtopic)} style={{ width: 300 }}>
                                        <FontAwesomeIcon className={styles.icon} icon={byPrefixAndName.fas['trash']} />
                                        Delete
                                    </LightButtonComponent>

                                </div>)}
                            <div className={styles.subtopicsAdd}>

                                {showAddSubtopic &&
                                    <>
                                        <New_InputTextComponent ref={subtopicRef} keyboardRef={keyboardRef} onChange={() => subtopicNameSave_handler()} height="80px" value="" placeHolder="Enter subtopic name here" styleType={'POPUP'} fontSize="40px"
                                            width={"1560px"}
                                            iconPosition="right" icon={byPrefixAndName.fas["pen"]} withDelete={true}
                                        />
                                        {showAddButton &&
                                            <LightButtonComponent onClick={handleSubtopicAdd} style={{ width: 300 }}>
                                                Add
                                            </LightButtonComponent>
                                        }
                                    </>
                                }

                            </div>
                        </div>
                    </div>
                    <FooterButtonsComponent
                        darkClick={closePopup}
                        lightText={editTopic ? "Update" : "Create"}
                        lightClick={(nameRef.current?.value === "" || !nameRef.current?.value) ? () => { } : handleTopicAdd}
                        isOpaque={(nameRef.current?.value === "" || !nameRef.current?.value) }
                    />

                </RightBodyComponent>
            </PopupBodyComponent>

        </PopupBaseComponent>
    );

}

export default AddTopicsComponent;